// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dark{position:absolute;top:0;left:0;width:100%;min-height:100%;background:#555;padding:10px}.dark,.dark a{color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
